import { useGetProductsStatus } from '../apiHooks/productsStatus.hook';

export const useLegacyBillCheck = () => {
  const { productsStatus } = useGetProductsStatus();
  const isNewFlowAvailable = !!productsStatus?.billcheck?.newFlowAvailable;

  const billCheckState = productsStatus?.billcheck;

  return {
    billCheckState,
    lastBillCheck: billCheckState?.billChecks[0],
    isNewFlowAvailable,
  };
};
